/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React, {useContext} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {ExdsLayout, ExdsLayoutItem, ExdsText} from '@exds/core';
import Footer from '../Footer/Footer';
import './ErrorPage.css';
import {ExdsButtonTray} from '@exds/containers';
import {AppContext} from '../../AppContext';

function ErrorPage() {
  const {helpLink} = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { errorCode, errorMessage } = location.state || {};

  const description = 'If this error persists, contact the HelpDesk using the link below.';

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleTertiaryClick = () => {
    window.open(helpLink || '/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="error-page-shell">
      <ExdsLayout display="flex" flexDirection="column" alignItems="center" className="error-page-layout">
        <ExdsLayoutItem flexBasis="568px" flexShrink={1} className="error-page-card-layout-item">
          <ExdsLayout display="flex" flexDirection="column" gap="16px" className="error-page-content-layout">
            <div className="error-page-card-content">
              <ExdsText primitive="p" alignment="left" textStyle="headlineSmall" style={{ margin: 0 }} data-testid="error-header">
                Oh no! Something went wrong...
              </ExdsText>

              <ExdsText
                primitive="p"
                color="regular"
                textStyle="bodyMedium"
                className="landing-paragraph-top-margin"
              >
                <span className="error-message-line" data-testid="error-subHeader">
                  {errorMessage || 'An error has occurred. Please try again.'}
                </span>
                <span className="error-message-line error-description-line" data-testid="error-description">
                  {description}
                </span>
              </ExdsText>

              <ExdsText
                primitive="p"
                color="regular"
                textStyle="bodyMedium"
                className="landing-paragraph-top-margin"
                data-testid="error-code"
              >
                Error Code: {errorCode || 'Not Provided'}
              </ExdsText>


              <ExdsButtonTray
                style={{width: '100%', marginTop: '24px'}}
                primaryButton='Try Again'
                tertiaryButton='Contact Ask JPMC'
                onPrimaryButtonClick={handleBackClick}
                onTertiaryButtonClick={handleTertiaryClick}
              />

            </div>
          </ExdsLayout>
        </ExdsLayoutItem>
      </ExdsLayout>

      <Footer />
    </div>
  );
}

export default ErrorPage;
